export const NavbarHeight = "84px";

export const DefaultVerticalPadding = "6.4rem";
export const DefaultHorizontalPadding = "4.8rem";

export const DefaultScrollSize = "8px";
